import { chatifyApi, ChatifyClient } from '@webinex/chatify';
import { Flippo } from '@webinex/flippo';

export interface ChatSettings {
  flippo: Flippo;
  chatifyClient: ChatifyClient;
}

export const ChatSettings: ChatSettings = {} as any;

export function configureChatSettings(args: ChatSettings) {
  chatifyApi.settings.client = args.chatifyClient;
  Object.assign(ChatSettings, args);
}
